module.exports = __webpack_public_path__ + "static/media/tech_specs_icon.96afa0bc.svg";